export default __webpack_public_path__ + "static/media/down.b18c4764.svg";